import { apiService } from "./api.service";
import { IContentSet } from "@/models/interfaces/content/content-set.model.interface";
import { IResponseModel } from "@/models/interfaces/response.model.interface";
import { IContentSetDetailsRequest } from "@/models/interfaces/content/content-set-details-request.model.interface";
import { IState } from "@/models/interfaces/config/state.model.interface";
import { IDevice } from "@/models/interfaces/device/device.model.interface";
import { EnquiryType } from "@/enums/EnquiryType";

class ContentSetService {

  private static serviceInstance: ContentSetService;

  private constructor() { }

  public static get instance() {
    // Do you need arguments? Make it a regular method instead.
    return this.serviceInstance || (this.serviceInstance = new this());
  }

  public async create(contentSet: IContentSet)
: Promise<IResponseModel<IContentSet>> {
  return apiService.post(`/api/v1/contentset`, contentSet)
      .then((response) => {
          const result = response.data as IResponseModel<IContentSet>;
          return result;
      })
      .catch((error) => {
          const result: IResponseModel<IContentSet> = {
              success: false,
              result: null
          };
          return result;
      });
  }

  public async get()
  : Promise<IResponseModel<IContentSet[]>> {
    return apiService.get(`/api/v1/contentset`)
      .then((response) => {
            const result = response.data as IResponseModel<IContentSet[]>;
            return result;
        })
      .catch((error) => {
            const result: IResponseModel<IContentSet[]> = {
                success: false,
                result: []
            };
            return result;
        });
  }

  public async getContentSet(id: number)
  : Promise<IResponseModel<IContentSet>> {
    return apiService.get(`/api/v1/contentset/${id}`)
      .then((response) => {
            const result = response.data as IResponseModel<IContentSet>;
            return result;
        })
      .catch((error) => {
            const result: IResponseModel<IContentSet> = {
                success: false,
                result: null
            };
            return result;
        });
  }

  public async updateDetails(id: number, details: IContentSetDetailsRequest)
  : Promise<boolean> {
    return apiService.patch(`/api/v1/contentset/${id}`, details)
      .then((response) => {
        return true;
      })
      .catch((error) => {
        return false;
      });
  }

  public async updateState(id: number, state: IState)
  : Promise<boolean> {
    return apiService.patch(`/api/v1/contentset/${id}/state`, state)
      .then((response) => {
        return true;
      })
      .catch((error) => {
        return false;
      });
  }

  public async addContentSetDevice(id: number, device: IDevice)
  : Promise<boolean> {
    return apiService.patch(`/api/v1/contentset/${id}/devicetype`, device)
      .then((response) => {
        return true;
      })
      .catch((error) => {
        return false;
      });
  }

  public async removeContentSetDevice(contentSetId: number, device: IDevice)
  : Promise<boolean> {
    return apiService.delete(`/api/v1/contentset/${contentSetId}/devicetype/${device.deviceTypeId}`)
      .then((response) => {
        return true;
      })
      .catch((error) => {
        return false;
      });
  }

  public async addContentSetEnquiryType(id: number, enquiryType: EnquiryType)
  : Promise<boolean> {
    return apiService.patch(`/api/v1/contentset/${id}/enquirytype/${enquiryType}`)
      .then((response) => {
        return true;
      })
      .catch((error) => {
        return false;
      });
  }

  public async removeContentSetEnquiryType(contentSetId: number, enquiryType: EnquiryType)
  : Promise<boolean> {
    return apiService.delete(`/api/v1/contentset/${contentSetId}/enquirytype/${enquiryType}`)
      .then((response) => {
        return true;
      })
      .catch((error) => {
        return false;
      });
  }

  public async updateProcess(id: number, processId: number)
  : Promise<boolean> {
    return apiService.patch(`/api/v1/contentset/${id}/process`, { processId })
      .then((response) => {
        return true;
      })
      .catch((error) => {
        return false;
      });
  }

  public async updateProductCategory(id: number, productCategoryId: number)
: Promise<boolean> {
  return apiService.patch(`/api/v1/contentset/${id}/product/category`, { productCategoryId })
    .then((response) => {
      return true;
    })
    .catch((error) => {
      return false;
    });
}
}

// export a singleton instance in the global namespace
export const contentSetService = ContentSetService.instance;
